import { useEffect } from "react";
import { WithDefaultLayout } from "@/components/DefautLayout";
import { Page } from "@/types/Page";
import { useRouter } from "next/router";
import { useSession } from "next-auth/react";
import { UserInfo } from "@/functions/AuthorizationContext";
import { useAtomValue } from "jotai";
import { permissionsAtom } from "@/stores/permissionAtom";
import { useFetchWithAccessToken } from "@/functions/useFetchWithAccessToken";
import { BackendApiUrl } from "@/functions/BackendApiUrl";

interface CheckUnverifiedResponse {
    hasUnverifiedUserRoles: boolean;
}


const Home: Page = () => {
    const router = useRouter();
    const { data: session, status } = useSession();
    const user = session?.user as UserInfo;
    const permissionKeys = useAtomValue(permissionsAtom); 
    const { fetchGET } = useFetchWithAccessToken();

    
    const permissionRouteList = [
      {
        key: "akses_sidebar_pendaftaran_anggota",
        route: "/manajemen-anggota/pendaftaran-anggota-mpk",
      },
      {
        key: "akses_sidebar_ubah_data_sekolah_yayasan",
        route: "/manajemen-anggota/ubah-data-yayasan-dan-sekolah",
      },
      {
        key: "akses_sidebar_ubah_data_sekolah",
        route: "/manajemen-anggota/ubah-data-sekolah",
      },
      {
        key: "akses_sidebar_submit_lulusan",
        route: "/manajemen-anggota/submit-lulusan-potensial-calon-mahasiswa-fkip",
      },
      {
        key: "akses_sidebar_pembayaran_iuran",
        route: "/manajemen-anggota/pembayaran-iuran-anggota-dan-history-bayar",
      },
      {
        key: "akses_sidebar_validasi_iuran_non_payment",
        route: "/manajemen-anggota/validasi-pembayaran-iuran",
      },
      {
        key: "akses_sidebar_manajemen_lowongan_pekerjaan",
        route: "/manajemen-anggota/lowongan-pekerjaan",
      },
      {
        key: "akses_sidebar_manajemen_pelamar_pekerjaan",
        route: "/manajemen-anggota/pelamar-pekerjaan",
      },
    
      // program kerja
      {
        key: "akses_sidebar_program_kerja",
        route: "/manajemen-program-kerja",
      },
    
      // manajemen mitra
      {
        key: "akses_sidebar_manajemen_alumni_fkip",
        route: "/manajemen-mitra/manajemen-alumni-fkip",
      },
      {
        key: "akses_sidebar_manajemen_calon_guru",
        route: "/manajemen-mitra/manajemen-calon-guru",
      },
      {
        key: "akses_sidebar_manajemen_beasiswa",
        route: "/manajemen-mitra/manajemen-beasiswa",
      },
      {
        key: "akses_sidebar_manajemen_kandidat_penerima_beasiswa",
        route: "/manajemen-mitra/manajemen-kandidat-penerima-beasiswa",
      },
    ];

    useEffect(() => {
        if (status === "loading" || permissionKeys == null) return;
        const handleRouting = async () => {

          if (user?.role?.length === 2
        && user?.role?.includes('f2b93d46-2156-4470-bf6f-7e4f4c2f1a8b')
        && user?.role?.includes('0792ea85-7816-4907-b50b-f495d0fc67b8')) {
            if (user?.id) {
              const response = await fetchGET<CheckUnverifiedResponse>(
                `${BackendApiUrl.access.getUserHasUnverifiedRole}?Id=${user.id}`
              );
              
              if (response?.data && response.data.hasUnverifiedUserRoles === true) {
                router.replace('/no-role-access');
                return;
              } else {
                router.replace('/first-time-access');
                return;
              }
            }
            else {
              router.replace('/no-role-access-manajemen-anggota');
              return;
            }
          }

          const firstPermission = permissionRouteList.find(item =>
            permissionKeys.includes(item.key)
          );
          
          if (firstPermission) {
            router.replace(firstPermission.route);
          } else {
            router.replace('/no-role-access-manajemen-anggota');
          }
          return;
        };

        handleRouting();
    }, [router, user, status, permissionKeys]);

    if (status == "loading") {
      return (
        <em>Loading...</em>
      )
    }

    return null;
};

Home.layout = WithDefaultLayout;
export default Home;